import {FORM_FIELDS} from '@/constants/help/form';

export const REPORT_MAIN_CATEGORY = [
  {label: '불법/음란', value: 'NODE0000000133'},
  {label: '저작권 침해', value: 'NODE0000000134'},
  {label: '명예훼손', value: 'NODE0000000135'},
  {label: '청소년 유해', value: 'NODE0000000136'},
  {label: '기타', value: 'NODE0000000137'},
];

export const REPORT_FIELD_ORDER = [
  FORM_FIELDS.OS_INFO,
  FORM_FIELDS.MAIN_CATEGORY,
  FORM_FIELDS.EMAIL,
  FORM_FIELDS.TITLE,
  FORM_FIELDS.CONTENT,
  FORM_FIELDS.FILES,
  FORM_FIELDS.AGREEMENT,
];

// 신고하기 페이지 > content placeholder
export const REPORT_DEFAULT_TEMPLATE = `신고 내용을 상세히 적어 주시면 감사하겠습니다.
\n※ 스트리머 및 유저가 운영정책을 위반하는 행위를 목격할 경우 신속, 정확한 확인을 위해 위반대상 아이디 또는 닉네임, 발생일시 위반 내용을 기재해주시면 감사하겠습니다. 건강한 커뮤니티 생태계를 만들기 위해 노력하겠습니다.`;
